module.exports = "/assets/data/f5adb5b6f1b85bf89bc4c7433727992e-M23.data.json";